import { Fragment, useEffect, useState } from "react";

import { ElementGroup, Title } from "styles/components";
import styled from "styled-components";
import { LazyChart } from "..";

import {
  ServiceGuideInfo,
  StatisticsContentsGrid,
  StatisticsDateGrid,
  StatisticsSearchOption,
} from "pages/statistics/Statistics";
import { numberComma } from "pages/calculate/components/manage";
import { useContextHomeTotal } from "../store/provierHook";
import useAuth from "store/modules/auth/authHook";

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;

  > div {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const ElementRroupWrap = styled(ElementGroup.Row)`
  margin: 24px 0 6px 0;
`;

export const HomeTotalDataWrapper = styled.div<{ length?: number }>`
  width: 100%;
  display: flex;

  .home-total-data-container {
    position: relative;
    width: ${props => (props.length ? `calc(100% / ${props.length})` : `calc(100% / 3)`)};
    padding: 25px 20px;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    border: 1px solid var(--border-normal);
    margin-right: 10px;
    &:last-child {
      margin: 0;
    }

    .title {
      color: #7c8484;
      font-size: 1rem;
      margin-bottom: 4px;
      display: flex;
      flex-wrap: wrap;
      .notice {
        margin-left: 8px;
        font-size: 0.96rem;
        color: #e65f3e;
      }
    }
    > p {
      &:last-child {
        color: #161c1c;
        font-size: 1.6rem;
        font-weight: 700;
        animation: animateNumber 1s linear; /* 숫자 증가 애니메이션 적용 */
      }
    }
  }

  /* 숫자 증가 애니메이션 */
  @keyframes animateNumber {
    from {
      opacity: 0;
      transform: translateY(20px); /* 약간 위로 이동 */
    }
    to {
      opacity: 1;
      transform: translateY(0); /* 다시 원래 위치로 이동 */
    }
  }
`;

export function NumberCountAnimation(props: { num: number; text: string; duration?: number }) {
  const [animatedValues, setAnimatedValues] = useState(0);

  useEffect(() => {
    const animationDuration = props.duration ? props.duration : 1300;
    const intervalDuration = 20;
    const framesCount = Math.ceil(animationDuration / intervalDuration); // 올림으로 변경하여 정확히 끝에 도달하도록
    const valueIncrement = props.num / framesCount;
    let currentValue = 0;

    const intervalId = setInterval(() => {
      currentValue = Math.min(currentValue + valueIncrement, props.num);
      setAnimatedValues(currentValue);
    }, intervalDuration);

    setTimeout(() => {
      clearInterval(intervalId);
      setAnimatedValues(props.num); // 애니메이션 끝에 정확히 목표값 설정
    }, animationDuration);

    return () => clearInterval(intervalId);
  }, [props.num, props.duration]);
  return (
    <p>
      {numberComma(Math.floor(animatedValues))}
      {/* {numberComma(animatedValues)} */}
      {props.text}
    </p>
  );
}

function HomeTotalData() {
  const { total } = useContextHomeTotal();
  const month = new Date().getMonth() + 1;

  const data = [
    { text: "전체 조회수", value: total && total.total_page_view ? total.total_page_view : 0 },
    {
      text: "올해 총 수익",
      value: total && total.total_calculator ? total.total_calculator : 0,
    },
    {
      text: `${month}월 예상 정산액`,
      value: total && total.expect_revenue ? total.expect_revenue : 0,
    },
  ];

  return (
    <HomeTotalDataWrapper>
      {data.map((item, idx) => (
        <div className="home-total-data-container" key={idx}>
          <div className="title">
            {item.text}
            {idx === data.length - 1 && <p className="notice">*실제 정산되는 금액과는 상이할 수 있습니다.</p>}
          </div>

          <NumberCountAnimation num={item.value} text={idx === 0 ? "회" : "원"} />
        </div>
      ))}
    </HomeTotalDataWrapper>
  );
}

function HomeContainer() {
  return (
    <>
      <HomeTotalData />

      <ElementRroupWrap>
        <StatisticsSearchOption tab={"PROVIDER"} />
      </ElementRroupWrap>

      <LazyChart />
      <StatisticsDateGrid tab={"PROVIDER"} />
      <StatisticsContentsGrid tab={"PROVIDER"} />
    </>
  );
}
/**
 * 통계 페이지
 * @returns JSX.Element
 */
export function ProviderHome(): JSX.Element {
  const { service_type } = useAuth();

  return service_type?.includes("PROVIDER") ? (
    <Fragment>
      <Title size="lg" weight="medium">
        홈
      </Title>

      <HomeContainer />
    </Fragment>
  ) : (
    <ServiceGuideInfo tab="PROVIDER" />
  );
}

export default ProviderHome;
